/*
 * Public API Surface of ng-generic-pipe
 */
export * from './lib/ng-generic-pipe.module';
export * from './lib/ng-generic-pipe.pipe';
